<template>
  <div class="w-100 d-flex justify-content-between flex-wrap mt-2">
    <div class="w-50 px-2 mb-1">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.name") }}
      </p>
      <b-form-input
        v-model="$v.name.$model"
        :class="{ 'border border-danger rounded': $v.name.$error }"
        name="name"
        type="text"
      />
    </div>
    <div class="w-50 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.email") }}
      </p>
      <b-form-input
        v-model="$v.email.$model"
        :class="{ 'border border-danger rounded': $v.email.$error }"
        name="email"
        type="email"
      />
    </div>
    <div class="w-50 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.phone") }}
      </p>
      <b-form-input
        v-model="$v.phone.$model"
        :class="{ 'border border-danger rounded': $v.phone.$error }"
        name="phone"
        type="text"
      />
    </div>
    <div class="w-50 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.companies") }}
      </p>
      <b-form-input v-model="companies" type="text" disabled />
    </div>
    <div class="w-50 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.department") }}
      </p>
      <b-form-input
        v-model="$v.department.$model"
        :class="{ 'border border-danger rounded': $v.department.$error }"
        name="department"
        type="text"
      />
    </div>
    <div class="w-50 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.roles") }}
      </p>
      <b-form-input v-model="role" type="text" disabled />
    </div>
    <div class="w-100 px-2">
      <p class="font-weight-bold my-2 fs-16">
        {{ $t("field.signature") }}
      </p>
      <div class="d-flex align-items-center">
        <image-uploader
          :max-width="1920"
          className="d-none"
          :quality="1"
          :auto-rotate="true"
          :preview="false"
          outputFormat="verbose"
          accept="image/*"
          do-not-resize="['gif', 'svg']"
          @input="imageUploaded"
        >
          <label
            for="fileInput"
            slot="upload-label"
            class="d-inline-flex align-items-center justify-content-between mb-0"
          >
            <div
              class="choose-signature-btn rounded px-5 py-2 fs-14 shadow-sm border border-primary text-primary align-items-center justify-content-center"
            >
              <span>{{ $t("actions.pick_signature") }}</span>
            </div>
          </label>
        </image-uploader>
        <b-button
          v-if="signature"
          variant="unstyled"
          @click.stop="removeImage"
          class="d-flex align-items-center justify-content-center ml-1 bg-gray-600 text-white rounded-pill fs-12 text-"
          >{{ $t("messages.remove_image") }}
          <font-awesome-icon :icon="faTimesCircle" class="ml-1 text-white"
        /></b-button>
      </div>
      <div class="mt-4">
        <img :src="signature" class="w-auto mw-100" />
      </div>
    </div>
    <div class="w-100 mt-5 d-flex justify-content-end">
      <b-button variant="primary" @click.stop="updateUser" class="mr-2">{{
        $t("actions.save")
      }}</b-button>
      <b-button variant="secondary" @click.stop="hideForm">{{
        $t("actions.cancel")
      }}</b-button>
    </div>
  </div>
</template>
<script>
import edit from '@/mixins/edit'
import model from '@/models/users'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [edit],
  data: () => ({
    model: JSON.parse(JSON.stringify(model.empty)),
    faTimesCircle,
    loading: true,
    name: null,
    email: null,
    phone: null,
    department: null,
    role: null,
    companies: null,
    signature: null
  }),
  created() {
    this.init()
  },
  methods: {
    init() {
      this.name = this.$auth.user().name
      this.email = this.$auth.user().email
      this.phone = this.$auth.user().phone
      this.department = this.$auth.user().department
      this.role = this.$auth.user().roles[0].name
      this.signature = this.$auth.user().file ? this.$auth.user().file : ''
      this.companies = Object.keys(this.$auth.user().companies)
        .map(company => {
          return this.$auth.user().companies[company].name + ' '
        })
        .toString()

      this.loading = false
    },
    hideForm() {
      this.$emit('hideForm')
      this.name = this.$auth.user().name
      this.email = this.$auth.user().email
      this.phone = this.$auth.user().phone
      this.department = this.$auth.user().department
    },
    async updateUser(modalEvt) {
      this.$v.$touch()
      modalEvt.preventDefault()

      if (this.$v.$invalid) {
        this.$toasted.error(this.$t('form.error'))
        return
      } else {
        this.$emit(
          'updateUser',
          this.name,
          this.email,
          this.phone,
          this.department,
          this.signature
        )
      }
    },
    imageUploaded(file) {
      this.setImage(file.dataUrl)
      this.signature = file.dataUrl
    },
    removeImage() {
      this.signature = null
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required
    },
    phone: {
      required
    },
    department: {
      required
    }
  }
}
</script>
<style lang="scss" scoped>
.choose-signature-btn {
  cursor: pointer;
}
</style>
